<script>
    import { getNewIcon } from "../../card_images";
	import "../shared.css";

	export let skill;
	$: isWild = skill === 'wild';
	$: border = skill === 'variable' ? '3px solid #222222' : 'none';

	function getSize(i){
		return `calc(var(--height) / ${401 / i})`;
	}
</script>

<div class="skill-badge" style="--b:{border}">
	{#if isWild || skill === 'research'}
		<div
			class="skill res"
			style="--iconSize:{isWild ? getSize(14) : getSize(24)};--hTranslate:{isWild ? '-30%' : '-35%'}"
		>
			<img src={getNewIcon('research')} />
		</div>
	{/if}
	{#if isWild || skill === 'influence'}
		<div
			class="skill inf"
			style="--iconSize:{isWild ? getSize(13) : getSize(22)};--hTranslate:{isWild ? '15%' : '-35%'}"
		>
			<img src={getNewIcon('influence')} />
		</div>
	{/if}
	{#if isWild || skill === 'military'}
		<div
			class="skill mil"
			style="--iconSize:{isWild ? getSize(14) : getSize(24)};--hTranslate:{isWild ? '-40%' : '-35%'}"
		>
			<img src={getNewIcon('military')} />
		</div>
	{/if}
	{#if skill === 'variable'}
		<div class="skill ctx">?</div>
	{/if}
</div>

<style lang="scss">
	$res-main: rgba(0, 91, 127, 1);
	$res-secondary: rgba(45, 167, 215, 1);
	$inf-main: rgba(193, 180, 0, 1);
	$inf-secondary: rgba(233, 220, 32, 1);
	$mil-main: rgba(171, 0, 59, 1);
	$mil-secondary: rgba(210, 38, 98, 1);
	.skill-badge {
		height: calc(var(--height) / 12.531); //32px;
		width: calc(var(--height) / 8.911); //45px;
		border-radius: 0 calc(var(--height) / 16.04) calc(var(--height) / 16.04) 0; //0 25px 25px 0;
		border-top: var(--b);
		border-bottom: var(--b);
		overflow: hidden;
		flex-direction: column;
	}
	.skill {
		flex-grow: 1;
		position: relative;
		&.res {
			//box-shadow: inset 18px 0 15px -10px $res-main, inset -20px 0 15px -10px $res-main;
			box-shadow: inset calc(var(--height) / 22.278) 0 calc(var(--height) / 26.667) calc(0px - var(--height) / 40.1) $res-main, inset calc(0px - var(--height) / 20.05) 0 calc(var(--height) / 26.667) calc(0px - var(--height) / 22.278) $res-main;
			background: linear-gradient(
				0deg,
				$res-main 0%,
				$res-secondary 25%,
				$res-main 50%,
				$res-secondary 75%,
				$res-main 100%
			);
		}
		&.inf {
			//box-shadow: inset 18px 0 15px -10px $inf-main, inset -20px 0 15px -10px $inf-main;
			box-shadow: inset calc(var(--height) / 22.278) 0 calc(var(--height) / 26.667) calc(0px - var(--height) / 40.1) $inf-main, inset calc(0px - var(--height) / 20.05) 0 calc(var(--height) / 26.667) calc(0px - var(--height) / 22.278) $inf-main;
			background: linear-gradient(
				0deg,
				$inf-main 0%,
				$inf-secondary 25%,
				$inf-main 50%,
				$inf-secondary 75%,
				$inf-main 100%
			);
		}
		&.mil {
			//box-shadow: inset 18px 0 15px -10px $mil-main, inset -20px 0 15px -10px $mil-main;
			box-shadow: inset calc(var(--height) / 22.278) 0 calc(var(--height) / 26.667) calc(0px - var(--height) / 40.1) $mil-main, inset calc(0px - var(--height) / 20.05) 0 calc(var(--height) / 26.667) calc(0px - var(--height) / 22.278) $mil-main;
			background: linear-gradient(
				0deg,
				$mil-main 0%,
				$mil-secondary 25%,
				$mil-main 50%,
				$mil-secondary 75%,
				$mil-main 100%
			);
		}
		&.ctx {
			background-color: azure;
			justify-content: flex-end;
			padding-right: calc(var(--height) / 40.1); //10px;
			font-family: 'trade-gothic-next';
			font-weight: 800;
			font-size: 1.5em;
		}
		& > :global(img) {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(var(--hTranslate), -50%);
			height: var(--iconSize);
			z-index: 10;
		}
	}
</style>
